import { FaucetIcon } from './FaucetIcon';

/**
 * author: Michael Irigoyen
 * id AEE38946-ADDE-4AFA-B450-D13590926CA4
 * name faucet
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/faucet.svg
 * tags
 * - Home Automation 
 */
export const BathroomTapIcon = FaucetIcon;
export default BathroomTapIcon